import React ,{useState } from 'react'
import axios from "axios";

const Login= () => {
 const [username, setusername] = useState('') ;
 const [password, setpassword] = useState('') ;
 const [error, seterror] = useState('') ;

 const handelSubmit = async(e)=> {

    e.preventDefault();
    const authObject = { 'Project-ID' : "2f40a4f7-1e90-4360-a521-59374e20545c", 'User-Name': username , 'User-Secret': password }
   try {
      await axios.get('https://api.chatengine.io/chats',{headers : authObject})
      localStorage.setItem('username', username) ;
      localStorage.setItem('password', password) ;
      window.location.reload();
   } catch (error) {
       seterror('Oops! ,incorrect credentials')
   }
 }

    return (
    
        <div className="wrapper">
            <div className="form">
                <h1 className="title">Let's Chat !!!</h1>
                <form onSubmit = {handelSubmit}>
                    <input type="text" value= {username} onChange = { (e)=> setusername(e.target.value)} className = 'input' placeholder = 'Username' required/>
                    <input type="password" value= {password} onChange = { (e)=> setpassword(e.target.value)}  className = 'input' placeholder = 'Password' required/>
                    <div  align = "center">
                        <button type = "submit" className = "button">
                            <span> Start Chatting</span>
                        </button>
                        <h2 className = "error">{error}</h2>
                    </div>
                </form>

            </div>
        </div>

    )
}

export default Login
